<template>
  <component :is="maintenance.active ? 'maintenance' : layout"></component>
</template>

<script>
import Maintenance from "./views/Maintenance.vue";
import LoginLayout from "./views/layouts/LoginLayout";
import DashboardLayout from "./views/layouts/DashboardLayout";

import { mapState } from "vuex";

export default {
  components: { Maintenance, LoginLayout, DashboardLayout },
  computed: {
    ...mapState(["layout", "maintenance"])
  }
};
</script>
